import { useCallback, useEffect, useRef } from 'react';

import { useApplicationState } from '@atlas/core';

import { POSTHOG_EVENTS } from 'common/constants';

import usePostHog from './usePostHog';

const useAlternativePaymentPostHog = () => {
  const postHog = usePostHog();
  const isSentRef = useRef(false);
  const isInitializedRef = useRef(false);
  const { account } = useApplicationState();

  useEffect(() => {
    if (isInitializedRef.current) return;
    isInitializedRef.current = true;

    postHog.concat(POSTHOG_EVENTS.ALTERNATIVE_PAYMENT_METHOD_POP_UP, {
      PM_clicked: null,
      client_id: account.id,
      manual_close_timestamp: null,
      shown_timestamp: Date.now(),
      view_all_clicked: null,
    });
  }, [account.id, postHog]);

  useEffect(() => {
    return () => {
      if (!isSentRef.current) {
        postHog.send(POSTHOG_EVENTS.ALTERNATIVE_PAYMENT_METHOD_POP_UP, {
          manual_close_timestamp: Date.now(),
        });
      }
    };
  }, [postHog]);

  const handleClose = useCallback(() => {
    if (isSentRef.current) return;

    postHog.send(POSTHOG_EVENTS.ALTERNATIVE_PAYMENT_METHOD_POP_UP, {
      manual_close_timestamp: Date.now(),
    });
    isSentRef.current = true;
  }, [postHog]);

  const handleSelectMethod = useCallback(
    method => {
      if (isSentRef.current) return;

      postHog.send(POSTHOG_EVENTS.ALTERNATIVE_PAYMENT_METHOD_POP_UP, {
        PM_clicked: method?.name ?? null,
      });
      isSentRef.current = true;
    },
    [postHog],
  );

  const handleViewAll = useCallback(() => {
    if (isSentRef.current) return;

    postHog.send(POSTHOG_EVENTS.ALTERNATIVE_PAYMENT_METHOD_POP_UP, {
      view_all_clicked: Date.now(),
    });
    isSentRef.current = true;
  }, [postHog]);

  return { handleClose, handleSelectMethod, handleViewAll };
};

export default useAlternativePaymentPostHog;
